module.exports = __webpack_public_path__ + "img/DK15731249.d4f9ac53.png";